import { nafColor } from '@nafcore/theme';
import { NafThemeType } from './themeTypes';

const { signature, primary, secondary, neutral, information } = nafColor;

export const nafThemeLight: NafThemeType = {
  fontFamilies: {
    default: 'questa-sans, -system-ui, system-ui, sans-serif',
    quote: 'questa-slab, -system-ui, system-ui, sans-serif',
    headers: 'questa-sans, -system-ui, system-ui, sans-serif',
    special: 'questa-sans, -system-ui, system-ui, sans-serif',
  },
  typography: {
    defaultText: signature.black,
    defaultTextInverted: signature.white,
    subtleText: neutral.neutral4,
    subtleTextInverted: neutral.neutral3,
    brandText: primary.spruce,
    brandTextInverted: primary.dew,
    disabledText: neutral.neutral4,
    disabledTextInverted: neutral.neutral3,
    textLink: primary.park,
    textLinkInverted: primary.kart,
  },
  background: {
    default: signature.white,
    important: signature.yellow20,
    brand: primary.dew,
    brandInverted: primary.spruce,
  },
  componentColors: {
    extras: {
      accent: primary.park,
    },
    interactiveElement: {
      active: signature.yellow,
      disabled: neutral.neutral3,
      hover: signature.yellow20,
    },
    inputElement: {
      backgroundDisabled: neutral.neutral1,
      backgroundDefault: signature.white,
      borderDefault: neutral.neutral4,
      borderActive: signature.black,
    },
    cta: {
      primary: signature.yellow,
      primaryHover: signature.yellow40,
      secondary: primary.moss,
      secondaryHover: primary.kart,
      secondaryInverted: primary.spruce,
      secondaryInvertedHover: primary.moss,
      disabled: neutral.neutral1,
    },
    navigation: {
      active: primary.park,
      inactive: neutral.neutral3,
    },
    alert: {
      successBackground: information.succesLight,
      success: information.successDark,
      errorBackground: information.errorLight,
      error: information.errorDark,
      warning: information.warning,
      warningBackground: information.warningLight,
      info: information.information,
      infoLight: information.informationLight,
    },
  },
  maps: {
    pointOfInterest: {
      primary: {
        light: primary.kart,
        medium: primary.park,
        dark: primary.spruce,
      },
      active: signature.yellow,
      extra1: {
        light: secondary.cloudberry,
        medium: '#ff6666',
        dark: '#330f1a',
      },
      extra2: {
        light: '#ababed',
        medium: '#755cff',
        dark: '#383373',
      },
    },
  },
  border: {
    default: neutral.neutral3,
    subtle: neutral.neutral2,
    heavy: neutral.neutral4,
    defaultInverted: neutral.neutral4,
    subtleInverted: neutral.neutral5,
    heavyInverted: neutral.neutral2,
  },
};
